var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4204 3.68014C11.4288 3.26523 11.4137 3.00306 11.4137 3.00306L7.51976 3H7.5H7.48024L3.58588 3.00306C3.58588 3.00306 3.57117 3.26523 3.57957 3.68014H1V4.12307C1 4.22417 1.01639 6.60904 2.42997 7.91549C3.01969 8.46039 3.75527 8.73437 4.62241 8.73481C4.75356 8.73481 4.88848 8.72562 5.02509 8.71336C5.51772 9.41583 6.08685 9.90777 6.72701 10.1529V12.0983H4.84771V13.3168H4.22688V14H7.48024H7.51976H10.7731V13.3172H10.1519V12.0988H8.27257V10.1533C8.91231 9.90821 9.48186 9.41627 9.97449 8.7138C10.1119 8.72606 10.2469 8.73481 10.378 8.73481C11.2447 8.73394 11.9803 8.46039 12.57 7.91505C13.9836 6.6086 14 4.22373 14 4.12263V3.68014H11.4204ZM2.99741 7.25504C2.18996 6.511 1.95121 5.23738 1.88059 4.56599H3.62833C3.70231 5.40238 3.87633 6.44447 4.27774 7.36052C4.3513 7.52859 4.42864 7.6879 4.50766 7.84371C3.90533 7.81964 3.39841 7.624 2.99741 7.25504ZM12.0026 7.25504C11.602 7.62444 11.0947 7.81964 10.4928 7.84371C10.5718 7.68834 10.6491 7.52859 10.7227 7.36052C11.1241 6.44447 11.2981 5.40238 11.3717 4.56599H13.1194C13.0488 5.23694 12.8105 6.51056 12.0026 7.25504Z",
    fill: "url(#paint0_linear_14_4151)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14_4151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4204 2.68014C12.4288 2.26523 12.4137 2.00306 12.4137 2.00306L8.51976 2H8.5H8.48024L4.58588 2.00306C4.58588 2.00306 4.57117 2.26523 4.57957 2.68014H2V3.12307C2 3.22417 2.01639 5.60904 3.42997 6.91549C4.01969 7.46039 4.75527 7.73437 5.62241 7.73481C5.75356 7.73481 5.88848 7.72562 6.02509 7.71336C6.51772 8.41583 7.08685 8.90777 7.72701 9.15287V11.0983H5.84771V12.3168H5.22688V13H8.48024H8.51976H11.7731V12.3172H11.1519V11.0988H9.27257V9.1533C9.91231 8.90821 10.4819 8.41627 10.9745 7.7138C11.1119 7.72606 11.2469 7.73481 11.378 7.73481C12.2447 7.73394 12.9803 7.46039 13.57 6.91505C14.9836 5.6086 15 3.22373 15 3.12263V2.68014H12.4204ZM3.99741 6.25504C3.18996 5.511 2.95121 4.23738 2.88059 3.56599H4.62833C4.70231 4.40238 4.87633 5.44447 5.27774 6.36052C5.3513 6.52859 5.42864 6.6879 5.50766 6.84371C4.90533 6.81964 4.39841 6.624 3.99741 6.25504ZM13.0026 6.25504C12.602 6.62444 12.0947 6.81964 11.4928 6.84371C11.5718 6.68834 11.6491 6.52859 11.7227 6.36052C12.1241 5.44447 12.2981 4.40238 12.3717 3.56599H14.1194C14.0488 4.23694 13.8105 5.51056 13.0026 6.25504Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14_4151",
    x: 0.1,
    y: 0.1,
    width: 16.8,
    height: 14.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14_4151"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14_4151",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_4151",
    x1: 7.5,
    y1: 3,
    x2: 7.5,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEB359"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.5b2d51e827df14f2b4121b9929c3ce90.svg";
export { ForwardRef as ReactComponent };